import React, { FC, SVGProps } from 'react';

import { getBrandName } from 'app/packages/brand';

const brandName = getBrandName();

export const BrandLogo: FC<SVGProps<SVGSVGElement>> = (props) => {
  // eslint-disable-next-line global-require
  const TheIcon = require(`../../packages/brand/logo/${brandName}/Logo`).default;

  return (
    <TheIcon { ...props} />
  );
};
